<template>
  <div class="user-management-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <h2 class="page-title">
        <i class="el-icon-user"></i>
        用户管理
      </h2>
      <div class="header-actions">
        <el-button type="primary" icon="el-icon-plus" @click="dialog.open = true">
          新建账号
        </el-button>
      </div>
    </div>

    <!-- 数据表格区域 -->
    <div class="table-container">
      <div class="table-header">
        <h3>用户列表</h3>
        <div class="table-tools">
          <el-input
              placeholder="搜索用户..."
              prefix-icon="el-icon-search"
              class="search-input"
              clearable>
          </el-input>
        </div>
      </div>

      <el-table
          :data="userInfo"
          border
          stripe
          style="width: 100%"
          class="custom-table"
          :header-cell-style="{background:'#f8f9fa', color:'#606266', fontWeight:'bold'}">
        <el-table-column prop="userName" label="手机号" align="center" min-width="120">
          <template slot-scope="scope">
            <i class="el-icon-phone"></i>
            {{ scope.row.phonenumber }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" min-width="150">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="单位名称" align="center" min-width="150">
          <template slot-scope="scope">
            <i class="el-icon-office-building"></i>
            {{ scope.row.userName }}
          </template>
        </el-table-column>
<!--        <el-table-column label="操作" align="center" min-width="120">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button type="text" size="small" icon="el-icon-edit">-->
<!--              编辑-->
<!--            </el-button>-->
<!--            <el-button type="text" size="small" icon="el-icon-delete" class="danger-text">-->
<!--              删除-->
<!--            </el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>

    <!-- 新建账号对话框 -->
    <el-dialog
        :title="dialog.title"
        :visible.sync="dialog.open"
        append-to-body
        width="500px"
        class="custom-dialog"
        :before-close="handleDialogClose">

      <el-form
          :model="secondInstance"
          :rules="formRules"
          ref="registerForm"
          label-width="100px"
          class="register-form">

        <el-form-item label="单位名称" prop="unitName">
          <!--          <el-input-->
          <!--              v-model="secondInstance.unitName"-->
          <!--              placeholder="请输入单位名称"-->
          <!--              prefix-icon="el-icon-office-building"-->
          <!--              clearable/>-->
          <el-select
              v-model="secondInstance.userName"
              placeholder="请输入单位名称"
              filterable
              allow-create
              clearable
              :popper-append-to-body="false"
              prefix-icon="el-icon-office-building">
            <el-option v-for="item in  unitNameList"
                       :label="item.companyName"
                       :value="item.companyName"
                       :key="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="手机号" prop="phonenumber">
          <el-input
              v-model="secondInstance.phonenumber"
              placeholder="请输入11位手机号"
              prefix-icon="el-icon-phone"
              maxlength="11"
              clearable/>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input
              v-model="secondInstance.password"
              type="password"
              placeholder="请输入密码（6-20位）"
              prefix-icon="el-icon-lock"
              show-password
              clearable/>
        </el-form-item>

        <el-form-item label="确认密码" prop="twoPassword">
          <el-input
              v-model="secondInstance.twoPassword"
              type="password"
              placeholder="请再次输入密码"
              prefix-icon="el-icon-lock"
              show-password
              clearable
              @blur="comparePasswords"/>
        </el-form-item>

        <el-form-item label="验证码" prop="captcha">
          <div class="captcha-container">
            <el-input
                v-model="secondInstance.captcha"
                placeholder="请输入验证码"
                prefix-icon="el-icon-key"
                class="captcha-input"
                clearable/>
            <div class="captcha-image-container">
              <img
                  :src="codeUrl"
                  class="captcha-image"
                  @click="refreshCode()"
                  title="点击刷新验证码">
              <el-button
                  type="text"
                  size="mini"
                  @click="refreshCode()"
                  class="refresh-btn">
                <i class="el-icon-refresh"></i>
              </el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取消</el-button>
        <el-button type="primary" @click="register" :loading="submitLoading">
          <i class="el-icon-check"></i>
          立即创建
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>


<script>
import {getCodeImg} from "@/api/login";
import {Message} from "element-ui";
import {getUnit, registration, unitByManagement} from "@/api/http";


export default {
  name: 'UserDisplay',
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };

    // 确认密码验证规则
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请确认密码'));
      } else if (value !== this.secondInstance.password) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };

    return {
      //选择单位下拉框
      unitNameList: [],
      //表单内容
      secondInstance: {
        unitName: '',
        phonenumber: '',
        password: '',
        twoPassword: '',
        captcha: '',
        uuid: ''
      },
      uuid: '',
      codeUrl: '',
      submitLoading: false,
      userInfo: [],
      dialog: {
        title: '创建新账号',
        open: false
      },
      // 表单验证规则
      formRules: {
        userName: [
          {required: true, message: '请输入单位名称', trigger: 'blur'},
          {min: 2, max: 50, message: '单位名称长度在 2 到 50 个字符', trigger: 'blur'}
        ],
        phonenumber: [
          {validator: validatePhone, trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur'}
        ],
        twoPassword: [
          {validator: validateConfirmPassword, trigger: 'blur'}
        ],
        // captcha: [
        //   {required: true, message: '请输入验证码', trigger: 'blur'},
        //   {min: 4, max: 6, message: '验证码长度在 4 到 6 个字符', trigger: 'blur'}
        // ]
      }
    }
  },

  methods: {


    //转换一下名字
    changeUnitName() {
      if (this.secondInstance.unitName === '泰安市农业科学院（山东省农业科学院泰安市分院）') {
        this.secondInstance.unitName = "泰安市农业科学院"
      }
    },
    // 获取验证码
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.secondInstance.uuid = res.uuid;
          this.uuid = res.uuid;
        }
      }).catch(error => {
        Message.error('获取验证码失败');
        console.error('获取验证码错误:', error);
      });
    },

    // 刷新验证码
    refreshCode() {
      this.getCode();
      Message.success('验证码已刷新');
    },

    // 比较密码
    comparePasswords() {
      if (this.secondInstance.password && this.secondInstance.twoPassword) {
        if (this.secondInstance.password !== this.secondInstance.twoPassword) {
          Message.error('两次密码不同，请确认密码');
        }
      }
    },

    // 注册用户
    register() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          // 这里应该调用实际的注册API
          registration(this.secondInstance).then(res => {
            if (res.code === 200) {
              Message.success("创建账号成功")

              // this.submitLoading = false;
              Message.success('账号创建成功!');
              this.handleDialogClose();
              // 刷新用户列表
              this.getCurrent();
            }
          })
        } else {
          Message.error('请检查表单填写是否正确');
          return false;
        }
      });
    },

    // 关闭对话框
    handleDialogClose() {
      this.dialog.open = false;
      this.$refs.registerForm.resetFields();
      this.secondInstance = {
        userName: '',
        phonenumber: '',
        password: '',
        twoPassword: '',
        captcha: '',
        uuid: ''
      };
      this.getCode(); // 重新获取验证码
    },

    // 获取用户列表（示例方法）
    getUserList() {
      // 这里应该调用实际的API获取用户列表
      console.log('获取用户列表');
    },


    //获取可以设置二级管理的单位
    getSecondaryManagement() {
      getUnit().then(res => {
        if (res.code === 200) {
          this.unitNameList = res.data
          console.log("this.unitNameList",this.unitNameList);
        }
      })
    },
    getCurrent(){
      const param = {
        management:1
      }
      unitByManagement(param).then(res=>{
        this.userInfo = res.data;
      })
    }
  },
  mounted() {
    this.getCode();
    this.getSecondaryManagement();
    this.getCurrent();
  }
}

</script>

<style scoped lang="scss">
.user-management-container {
  padding: 24px;
  //background: #f5f7fa;
  min-height: calc(100vh - 84px);

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 20px 24px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .page-title {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: #303133;
      display: flex;
      align-items: center;

      i {
        margin-right: 8px;
        color: #409eff;
      }
    }

    .header-actions {
      .el-button {
        padding: 12px 24px;
        border-radius: 6px;
        font-weight: 500;
      }
    }
  }

  .table-container {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 24px;
      border-bottom: 1px solid #ebeef5;
      background: #fafbfc;

      h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
      }

      .table-tools {
        .search-input {
          width: 280px;
        }
      }
    }

    .custom-table {
      border: none;

      ::v-deep .el-table__header {
        th {
          background: #f8f9fa !important;
          border-bottom: 2px solid #e9ecef;
        }
      }

      ::v-deep .el-table__body {
        tr {
          transition: background-color 0.3s ease;

          &:hover {
            background-color: #f8f9fa !important;
          }
        }

        td {
          padding: 16px 0;

          i {
            margin-right: 6px;
            color: #909399;
          }
        }
      }

      .danger-text {
        color: #f56c6c;

        &:hover {
          color: #f56c6c;
        }
      }
    }
  }
}

// 对话框样式
::v-deep .custom-dialog {
  .el-dialog {
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  }

  .el-dialog__header {
    padding: 24px 24px 16px;
    border-bottom: 1px solid #ebeef5;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px 24px;
    border-top: 1px solid #ebeef5;
    text-align: right;
  }
}

.register-form {
  .el-form-item {
    margin-bottom: 24px;

    .el-form-item__label {
      font-weight: 500;
      color: #606266;
    }

    .el-input {
      .el-input__inner {
        height: 40px;
        line-height: 40px;
        border-radius: 6px;
        border: 1px solid #dcdfe6;
        transition: all 0.3s ease;

        &:focus {
          border-color: #409eff;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
        }
      }
    }
  }

  .captcha-container {
    display: flex;
    align-items: center;
    gap: 12px;

    .captcha-input {
      flex: 1;
    }

    .captcha-image-container {
      position: relative;
      display: flex;
      align-items: center;

      .captcha-image {
        height: 40px;
        width: 120px;
        border: 1px solid #dcdfe6;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          border-color: #409eff;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
        }
      }

      .refresh-btn {
        margin-left: 8px;
        color: #409eff;

        &:hover {
          color: #66b1ff;
        }

        i {
          font-size: 16px;
        }
      }
    }
  }
}

.dialog-footer {
  .el-button {
    padding: 10px 20px;
    border-radius: 6px;
    font-weight: 500;

    &:first-child {
      margin-right: 12px;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .user-management-container {
    padding: 16px;

    .page-header {
      flex-direction: column;
      gap: 16px;

      .page-title {
        font-size: 20px;
      }
    }

    .table-container {
      .table-header {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;

        .table-tools {
          width: 100%;

          .search-input {
            width: 100%;
          }
        }
      }
    }
  }

  ::v-deep .custom-dialog {
    .el-dialog {
      width: 95% !important;
      margin: 5vh auto;
    }
  }

  .register-form {
    .captcha-container {
      flex-direction: column;
      align-items: stretch;

      .captcha-image-container {
        justify-content: center;
      }
    }
  }
}
</style>
